// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://gtkpyfabdpudfhxuieqv.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imd0a3B5ZmFiZHB1ZGZoeHVpZXF2Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY3ODk3MzUsImV4cCI6MjA1MjM2NTczNX0.9z_6A7n63VeeuZO4gfWDAi9sihOajdbSVbQzAX-mDpY";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);